<template>
  <section>
    <section>
      <b-container>
        <b-row class="text-center justify-content-center gap-4">
          <b-col
            class="py-3  shadow-radius bg-white d-flex flex-column align-items-center"
            v-for="action in secondaryActions"
            :key="action"
          >
            <b-skeleton-img no-aspect height="50px" width="50px" class="rounded"></b-skeleton-img>
            <b-skeleton class="mt-2" width="50%" heigth="30px"> </b-skeleton>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </section>
</template>

<script>
export default {
  data() {
    return {
      secondaryActions: [1, 2, 3],
    };
  },
};
</script>
